import { actionCreator } from '@ardoq/rxbeach';
import { type Row as TableRow } from '@ardoq/table';
import { type WorkspaceRowData } from 'components/AssetsBrowser/workspaceAssets$';

export const openSelectWorkspaceDialog = actionCreator(
  '[selectWorkspaceDialog] OPEN_WORKSPACES_BROWSER'
);

export const confirmSelectWorkspaceDialogSelection = actionCreator<{
  selectedIds: string[];
}>('[selectWorkspaceDialog] CONFIRM_SELECTION');

export const setSelectedWorkspaces = actionCreator<string[]>(
  '[selectWorkspaceDialog] SET_SELECTED_WORKSPACES'
);

export const setSearchPhrase = actionCreator<{
  phrase: string;
  rows: TableRow<WorkspaceRowData>[];
}>('[selectWorkspaceDialog] SET_SEARCH_PHRASE');

export const setExpandedIds = actionCreator<string[]>(
  '[selectWorkspaceDialog] SET_EXPANDED_IDS'
);

export const expandFolder = actionCreator<string>(
  '[selectWorkspaceDialog] EXPAND_FOLDER'
);

export const closeFolder = actionCreator<string>(
  '[selectWorkspaceDialog] CLOSE_FOLDER'
);
